import API from "../../../../../../global/api";

  //Post Data from 1 to 18 Questions

export const postData = (data) => {
    return (dispatch) => {
      API.put(`/form_160_assets/add-and-update-form-160-asset`, data).then((res) => {
        let dataPost = res.data;
        if(dataPost.data[0].asset_brief_description_id == 1){
          dispatch(successRealEstate(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==2) {
            dispatch(successHouseHold(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==3) {
            dispatch(successJewelary(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==4) {
            dispatch(successVehicles(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==5) {
            dispatch(successSavings(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==6) {
            dispatch(successChecking(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==7) {
            dispatch(successCredit(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==8) {
            dispatch(successCash(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==9) {
            dispatch(successTaxRefund(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==10) {
            dispatch(successLifeInsurance(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==11) {
            dispatch(successStocks(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==12) {
            dispatch(successRetirements(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==13) {
            dispatch(successProfit(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==14) {
            dispatch(successAccounts(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==15) {
            dispatch(successPartnership(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==16) {
            dispatch(successOtherAssets(dataPost));
          }
      });
    };
  };

  //Actions

  export const requestpostSeparateProperty = (data) => {
    return {
      type: "REQUEST_POST_SEPARATE_PROPERTY",
    };
  };
  export const successpostSeparateProperty = (data) => {
    return {
      type: "SUCCESS_POST_SEPARATE_PROPERTY",
      payload: data,
    };
  };
  export const errorpostSeparateProperty = (data) => {
    return {
      type: "ERROR_POST_SEPARATE_PROPERTY",
      payload: data,
    };
  };

   //Real Estate Action

   export const requestRealEstate = (data) => {
    return {
      type: "REQUEST_SEPARATE_REAL_ESTATE",
    };
  };
  export const successRealEstate = (data) => {
    return {
      type: "SUCCESS_SEPARATE_REAL_ESTATE",
      payload: data,
    };
  };
  export const errorRealEstate = (data) => {
    return {
      type: "ERROR_SEPARATE_REAL_ESTATE",
      payload: data,
    };
  };

  //House Hold Action

  export const requestHouseHold = (data) => {
    return {
      type: "REQUEST_SEPARATE_HOUSE_HOLD",
    };
  };
  export const successHouseHold = (data) => {
    return {
      type: "SUCCESS_SEPARATE_HOUSE_HOLD",
      payload: data,
    };
  };
  export const errorHouseHold = (data) => {
    return {
      type: "ERROR_SEPARATE_HOUSE_HOLD",
      payload: data,
    };
  };

  //Jewelary Action

  export const requestJewelary = (data) => {
    return {
      type: "REQUEST_SEPARATE_JEWELARY",
    };
  };
  export const successJewelary = (data) => {
    return {
      type: "SUCCESS_SEPARATE_JEWELARY",
      payload: data,
    };
  };
  export const errorJewelary = (data) => {
    return {
      type: "ERROR_SEPARATE_JEWELARY",
      payload: data,
    };
  };

  //Vehicles Action

  export const requestVehicles = (data) => {
    return {
      type: "REQUEST_SEPARATE_VEHICLES",
    };
  };
  export const successVehicles = (data) => {
    return {
      type: "SUCCESS_SEPARATE_VEHICLES",
      payload: data,
    };
  };
  export const errorVehicles = (data) => {
    return {
      type: "ERROR_SEPARATE_VEHICLES",
      payload: data,
    };
  };

  //Savings Action

  export const requestSavings = (data) => {
    return {
      type: "REQUEST_SEPARATE_SAVINGS",
    };
  };
  export const successSavings = (data) => {
    return {
      type: "SUCCESS_SEPARATE_SAVINGS",
      payload: data,
    };
  };
  export const errorSavings = (data) => {
    return {
      type: "ERROR_SEPARATE_SAVINGS",
      payload: data,
    };
  };

  //Checking Action

  export const requestChecking = (data) => {
    return {
      type: "REQUEST_SEPARATE_CHECKING",
    };
  };
  export const successChecking = (data) => {
    return {
      type: "SUCCESS_SEPARATE_CHECKING",
      payload: data,
    };
  };
  export const errorChecking = (data) => {
    return {
      type: "ERROR_SEPARATE_CHECKING",
      payload: data,
    };
  };

  //Credit Action

  export const requestCredit = (data) => {
    return {
      type: "REQUEST_SEPARATE_CREDIT",
    };
  };
  export const successCredit = (data) => {
    return {
      type: "SUCCESS_SEPARATE_CREDIT",
      payload: data,
    };
  };
  export const errorCredit = (data) => {
    return {
      type: "ERROR_SEPARATE_CREDIT",
      payload: data,
    };
  };

  //Cash Action

  export const requestCash = (data) => {
    return {
      type: "REQUEST_SEPARATE_CASH",
    };
  };
  export const successCash = (data) => {
    return {
      type: "SUCCESS_SEPARATE_CASH",
      payload: data,
    };
  };
  export const errorCash = (data) => {
    return {
      type: "ERROR_SEPARATE_CASH",
      payload: data,
    };
  };

  //Tax Refund Action

  export const requestTaxRefund = (data) => {
    return {
      type: "REQUEST_SEPARATE_TAX_REFUND",
    };
  };
  export const successTaxRefund = (data) => {
    return {
      type: "SUCCESS_SEPARATE_TAX_REFUND",
      payload: data,
    };
  };
  export const errorTaxRefund = (data) => {
    return {
      type: "ERROR_SEPARATE_TAX_REFUND",
      payload: data,
    };
  };

  //Life Insurance Action

  export const requestLifeInsurance = (data) => {
    return {
      type: "REQUEST_SEPARATE_LIFE_INSURANCE",
    };
  };
  export const successLifeInsurance = (data) => {
    return {
      type: "SUCCESS_SEPARATE_LIFE_INSURANCE",
      payload: data,
    };
  };
  export const errorLifeInsurance = (data) => {
    return {
      type: "ERROR_SEPARATE_LIFE_INSURANCE",
      payload: data,
    };
  };

  //Stocks Action

  export const requestStocks = (data) => {
    return {
      type: "REQUEST_SEPARATE_STOCKS",
    };
  };
  export const successStocks = (data) => {
    return {
      type: "SUCCESS_SEPARATE_STOCKS",
      payload: data,
    };
  };
  export const errorStocks = (data) => {
    return {
      type: "ERROR_SEPARATE_STOCKS",
      payload: data,
    };
  };

  //Retirements Action

  export const requestRetirements = (data) => {
    return {
      type: "REQUEST_SEPARATE_RETIREMENTS",
    };
  };
  export const successRetirements = (data) => {
    return {
      type: "SUCCESS_SEPARATE_RETIREMENTS",
      payload: data,
    };
  };
  export const errorRetirements = (data) => {
    return {
      type: "ERROR_SEPARATE_RETIREMENTS",
      payload: data,
    };
  };

  //Profit Action

  export const requestProfit = (data) => {
    return {
      type: "REQUEST_SEPARATE_PROFIT",
    };
  };
  export const successProfit = (data) => {
    return {
      type: "SUCCESS_SEPARATE_PROFIT",
      payload: data,
    };
  };
  export const errorProfit = (data) => {
    return {
      type: "ERROR_SEPARATE_PROFIT",
      payload: data,
    };
  };

  //Accounts Action

  export const requestAccounts = (data) => {
    return {
      type: "REQUEST_SEPARATE_ACCOUNTS",
    };
  };
  export const successAccounts = (data) => {
    return {
      type: "SUCCESS_SEPARATE_ACCOUNTS",
      payload: data,
    };
  };
  export const errorAccounts = (data) => {
    return {
      type: "ERROR_SEPARATE_ACCOUNTS",
      payload: data,
    };
  };

  //Partnership Action

  export const requestPartnership = (data) => {
    return {
      type: "REQUEST_SEPARATE_PARTNERSHIP",
    };
  };
  export const successPartnership = (data) => {
    return {
      type: "SUCCESS_SEPARATE_PARTNERSHIP",
      payload: data,
    };
  };
  export const errorPartnership = (data) => {
    return {
      type: "ERROR_SEPARATE_PARTNERSHIP",
      payload: data,
    };
  };

  //Other Assets Action

  export const requestOtherAssets = (data) => {
    return {
      type: "REQUEST_SEPARATE_OTHER_ASSETS",
    };
  };
  export const successOtherAssets = (data) => {
    return {
      type: "SUCCESS_SEPARATE_OTHER_ASSETS",
      payload: data,
    };
  };
  export const errorOtherAssets = (data) => {
    return {
      type: "ERROR_SEPARATE_OTHER_ASSETS",
      payload: data,
    };
  };

  //Continuation Assets Action

  export const requestContinuationAssets = (data) => {
    return {
      type: "REQUEST_SEPARATE_CONTINUATION_ASSETS",
    };
  };
  export const successContinuationAssets = (data) => {
    return {
      type: "SUCCESS_SEPARATE_CONTINUATION_ASSETS",
      payload: data,
    };
  };
  export const errorContinuationAssets = (data) => {
    return {
      type: "ERROR_SEPARATE_CONTINUATION_ASSETS",
      payload: data,
    };
  };

  //Get Data from 1 to 18 Questions

  export const successDescriptionOptionsData = () => {
    return (dispatch) => {
      API.get(`/form_160_assets/get-asset-brief-description`).then((res) => {
        //
        let data = res.data;
        dispatch(successGetSeparateProperty(data));
      });
    };
  };

  //Actions

  export const requestGetSeparateProperty = (data) => {
    return {
      type: "REQUEST_GET_SEPARATE_PROPERTY",
    };
  };
  export const successGetSeparateProperty = (data) => {
    return {
      type: "SUCCESS_GET_SEPARATE_PROPERTY",
      payload: data,
    };
  };
  export const errorGetSeparateProperty = (data) => {
    return {
      type: "ERROR_GET_SEPARATE_PROPERTY",
      payload: data,
    };
  };

  //Post Data from 18 to 24 Questions

  export const postSecondTableData = (data) => {
    return (dispatch) => {
      API.put(`/debts/add-and-update-debts`, data).then((res) => {
        let dataPost = res.data;
        if(dataPost.data[0].asset_brief_description_id ==18){
          dispatch(successStudentLoans(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==19) {
            dispatch(successTaxes(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==20) {
            dispatch(successSupport(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==21) {
            dispatch(successLoans(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==22) {
            dispatch(successCreditCards(dataPost));
          }
          else if (dataPost.data[0].asset_brief_description_id ==23) {
            dispatch(successDebts(dataPost));
          }
      });
    };
  };

  //Actions

  export const requestpostSecondTableSeparateProperty = (data) => {
    return {
      type: "REQUEST_POST_SECOND_TABLE_SEPARATE_PROPERTY",
    };
  };
  export const successpostSecondTableSeparateProperty = (data) => {
    return {
      type: "SUCCESS_POST_SECOND_TABLE_SEPARATE_PROPERTY",
      payload: data,
    };
  };
  export const errorpostSecondTableSeparateProperty = (data) => {
    return {
      type: "ERROR_POST_SECOND_TABLE_SEPARATE_PROPERTY",
      payload: data,
    };
  };

  //Student Loans Actions

  export const requestStudentLoans = (data) => {
    return {
      type: "REQUEST_SEPARATE_STUDENT_LOANS",
    };
  };
  export const successStudentLoans = (data) => {
    return {
      type: "SUCCESS_SEPARATE_STUDEBT_LOANS",
      payload: data,
    };
  };
  export const errorStudentLoans = (data) => {
    return {
      type: "ERROR_SEPARATE_STUDEBT_LOANS",
      payload: data,
    };
  };

    //Taxes Actions

export const requestTaxes = (data) => {
  return {
    type: "REQUEST_SEPARATE_TAXES",
  };
};
export const successTaxes = (data) => {
  return {
    type: "SUCCESS_SEPARATE_TAXES",
    payload: data,
  };
};
export const errorTaxes = (data) => {
  return {
    type: "ERROR_SEPARATE_TAXES",
    payload: data,
  };
};

  //Support Actions

  export const requestSupport = (data) => {
    return {
      type: "REQUEST_SEPARATE_SUPPORT",
    };
  };
  export const successSupport = (data) => {
    return {
      type: "SUCCESS_SEPARATE_SUPPORT",
      payload: data,
    };
  };
  export const errorSupport = (data) => {
    return {
      type: "ERROR_SEPARATE_SUPPORT",
      payload: data,
    };
  };

    //Loans Actions

export const requestLoans = (data) => {
  return {
    type: "REQUEST_SEPARATE_LOANS",
  };
};
export const successLoans = (data) => {
  return {
    type: "SUCCESS_SEPARATE_LOANS",
    payload: data,
  };
};
export const errorLoans = (data) => {
  return {
    type: "ERROR_SEPARATE_LOANS",
    payload: data,
  };
};

  //Credit Cards Actions

  export const requestCreditCards = (data) => {
    return {
      type: "REQUEST_SEPARATE_CREDIT_CARDS",
    };
  };
  export const successCreditCards = (data) => {
    return {
      type: "SUCCESS_SEPARATE_CREDIT_CARDS",
      payload: data,
    };
  };
  export const errorCreditCards = (data) => {
    return {
      type: "ERROR_SEPARATE_CREDIT_CARDS",
      payload: data,
    };
  };

    //Debts Actions

export const requestDebts = (data) => {
  return {
    type: "REQUEST_SEPARATE_DEBTS",
  };
};
export const successDebts = (data) => {
  return {
    type: "SUCCESS_SEPARATE_DEBTS",
    payload: data,
  };
};
export const errorDebts = (data) => {
  return {
    type: "ERROR_SEPARATE_DEBTS",
    payload: data,
  };
};

  //Continuation Debts Actions

  export const requestContinuationDebts = (data) => {
    return {
      type: "REQUEST_SEPARATE_CONTINUATION_DEBTS",
    };
  };
  export const successContinuationDebts = (data) => {
    return {
      type: "SUCCESS_SEPARATE_CONTINUATION_DEBTS",
      payload: data,
    };
  };
  export const errorContinuationDebts = (data) => {
    return {
      type: "ERROR_SEPARATE_CONTINUATION_DEBTS",
      payload: data,
    };
  };


export const getData = (data) => {

  return (dispatch) => {
    dispatch(requestGetData(data));
    API.post(`/form_160_assets/get-all-data`, data).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successGetData(data));
    });
  };
};

//Actions

export const requestGetData = (data) => {
  return {
    type: "REQUEST_GET_SEPARATE_DATA",
    payload: data,
  };
};
export const successGetData = (data) => {
  return {
    type: "SUCCESS_GET_SEPARATE_DATA",
    payload: data,
  };
};
export const errorGetData = (data) => {
  return {
    type: "ERROR_GET_SEPARATE_DATA",
    payload: data,
  };
};



//Delete Call

export const requestDeleteSeparateAssets = (data) => {
  return {
    type: "REQUEST_DELETE_SEPARATE_ASSETS",
  };
};
export const successDeleteSeparateAssets = (data) => {
  return {
    type: "SUCCESS_DELETE_SEPARATE_ASSETS",
    payload: data,
  };
};
export const errorDeleteSeparateAssets = (data) => {
  return {
    type: "ERROR_DELETE_SEPARATE_ASSETS",
    payload: data,
  };
};

export const  deleteSeparateAssetsCall = (data) => {
  return (dispatch) => {
    API.post(`/form_160_assets/delete-160-form-assets`,data).then((res) => {
      dispatch(successDeleteSeparateAssets(res.data));
    });
  };
};

// Delete call debits

export const requestDeleteSeparateDebits = (data) => {
  return {
    type: "REQUEST_DELETE_SEPARATE_DEBITS",
  };
};
export const successDeleteSeparateDebits = (data) => {
  return {
    type: "SUCCESS_DELETE_SEPARATE_DEBITS",
    payload: data,
  };
};
export const errorDeleteSeparateDebits = (data) => {
  return {
    type: "ERROR_DELETE_SEPARATE_DEBITS",
    payload: data,
  };
};

export const  deleteSeparateDebitsCall = (data) => {
  return (dispatch) => {
    API.post(`/debts/delete-160-form-debts`,data).then((res) => {
      dispatch(successDeleteSeparateDebits(res.data));
    });
  };
};
